import { render, staticRenderFns } from "./BalanceForm.vue?vue&type=template&id=9f0f027e&scoped=true&"
import script from "./BalanceForm.vue?vue&type=script&lang=js&"
export * from "./BalanceForm.vue?vue&type=script&lang=js&"
import style0 from "./BalanceForm.vue?vue&type=style&index=0&id=9f0f027e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0f027e",
  null
  
)

export default component.exports